import {
    get
} from '../Requisitions';
var config = require('../../config.json');

export var settings = {
    getSettings: function (page=null,admin) {
        return get('configuracao/' + admin+((page!=null&& page!=undefined)?'/'+page:''), {
            'Token': config.token
        });
    }
}